import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import React, { ReactElement } from 'react';
import { Modal } from '../../../../../../../../../../components';
import { Button } from '../../../../../../../../../../components/CiscoUi';
import { ViewAllNetworksModalProps } from './container';
import styles from './ViewAllNetworksModal.module.css';

export function ViewAllNetworksModal({
  viewAllNetworksModal,
  setViewAllNetworksModal,
}: ViewAllNetworksModalProps): ReactElement {
  const { t } = useTranslation();

  return (
    <Modal
      className={styles.stackedAboveConfigureModal}
      clickScreenToClose={true}
      show={!!viewAllNetworksModal}
      onClose={() => setViewAllNetworksModal(undefined)}
      headerAlignment="center"
      title={t('networks.trunk.networkOrVlans')}
    >
      <div className="flex flex-center base-margin-bottom dbl-margin-top">
        <ul className={classnames('text-left', styles.networkList)}>
          {viewAllNetworksModal?.map((name) => (
            <li key={name} className={styles.networkListItem}>
              {name}
            </li>
          ))}
        </ul>
      </div>

      <div className="flex flex-center dbl-margin-top">
        <Button onClick={() => setViewAllNetworksModal(undefined)}>
          {t('buttons.close')}
        </Button>
      </div>
    </Modal>
  );
}
